import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import ProjectLeads from './leads';
import { leadsStartingState } from './starting_state';
import rootReducer from 'bundles/project/reducers';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import LocalStoreFactory from 'helpers/redux/local_store_factory';
import { useBuildoutOsDisplay } from 'components/buildout_os_display';

const LEADS_TAB_KEY = 'leadsTab';
const OS_LEADS_TAB_KEY = 'osLeadsTab';

export default function Leads(props) {
  const buildoutOs = useBuildoutOsDisplay();
  const startingState = leadsStartingState(props);

  const storeFactory = new LocalStoreFactory(buildoutOs ? OS_LEADS_TAB_KEY : LEADS_TAB_KEY, { permit: ['session'] });
  const store = storeFactory.store(rootReducer, startingState, applyMiddleware(thunk));

  if (module.hot) {
    module.hot.accept('bundles/project/reducers/index', () => {
      store.replaceReducer(require('bundles/project/reducers/index'));
    });
  }

  return (
    <Provider store={store}>
      <ProjectLeads
        availableDatabaseOptions={props.availableDatabaseOptions}
        caDownloadPath={props.caDownloadPath}
        callLists={props.callLists}
        callListsEnabled={props.currentUser && props.currentUser.callListsEnabled}
        canDisplayEmailLink={props.canDisplayEmailLink}
        commercialEdgeLogoPath={props.commercialEdgeLogoPath}
        crmEnabled={props.crmEnabled}
        databaseMembers={[...props.project.collaborators, ...props.project.otherAuthorizedUsers]}
        defaultTaskAssignee={props.defaultTaskAssignee}
        emailCa={props.emailCa}
        leadFieldFormat={props.leadFieldFormat}
        leadReferralSources={props.leadReferralSourceFilterOptions}
        leadsPath={props.leadsPath}
        leadStatuses={props.leadStatuses}
        leaseSpace={props.leaseSpace}
        project={props.project}
      />
    </Provider>
  );
}

Leads.propTypes = {
  addLeadsToLists: PropTypes.bool,
  availableDatabaseOptions: PropTypes.array,
  caDownloadPath: PropTypes.string,
  callLists: PropTypes.array,
  canDisplayEmailLink: PropTypes.bool,
  commercialEdgeLogoPath: PropTypes.string,
  crmEnabled: PropTypes.bool,
  currentUser: PropTypes.object,
  defaultTaskAssignee: PropTypes.object,
  emailCa: PropTypes.bool,
  leadFieldFormat: PropTypes.object,
  leadReferralSourceFilterOptions: PropTypes.array,
  leadReferralSources: PropTypes.array,
  leadsPath: PropTypes.string,
  leadStatuses: PropTypes.array,
  leaseSpace: PropTypes.object,
  project: PropTypes.object,
};